import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {AppService, Host} from "../../../../common";

@Component({
  standalone: false,
  template: `
<main class="success container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-success">
    <i class="fa fa-check-circle fa-4x"></i>
  </p>
  <h3 class="text-center" i18n>Service Call sent</h3>
  <p class="text-center" i18n>
    The service call has been sent. A waiter will come to you shortly.
  </p>
  <p class="text-center">
    <button *ngIf="canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Close this window and go back to {{host.name}}</button>
    <button *ngIf="!canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Go back to {{host.name}}</button>
  </p>
</main>
  `
})

export class ServicecallSuccessPage {

  host: Host;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.appService.load().subscribe(({host, cart}) => {
        this.host = host;
      });
  }

  canClose() {
    return this.appService.canClose();
  }

  onBtClose(event): boolean {
    event.preventDefault();
    this.appService.closeApp();
    return false;
  }

}
